var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-waiting-table-component" },
    [
      _c("div", { staticClass: "room-waiting-table-wrapper" }, [
        _c("table", { staticClass: "room-waiting-table table-fixed" }, [
          _vm._m(0),
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "align-center" }, [
                _vm._v(_vm._s(_vm.$t("common.number"))),
              ]),
              _c("th", [_vm._v(_vm._s(_vm.$t("common.name")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("waitingRoom.join.time")))]),
              _c("th", { staticClass: "align-center" }, [
                _vm._v(_vm._s(_vm.$t("common.device.camera"))),
              ]),
              _c("th", { staticClass: "align-center" }, [
                _vm._v(_vm._s(_vm.$t("common.device.mic"))),
              ]),
              _c("th", { staticClass: "align-center" }, [
                _vm._v(_vm._s(_vm.$t("setting.join.role.title"))),
              ]),
              _c("th", { staticClass: "align-center" }, [
                _vm._v(_vm._s(_vm.$t("deviceSetting.preview.join.request"))),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("perfect-scrollbar", [
        _c("div", { staticClass: "room-waiting-table-wrapper body" }, [
          _c("table", { staticClass: "room-waiting-table table-fixed" }, [
            _c("colgroup", [
              _c("col", { attrs: { width: "5%" } }),
              _c("col", { attrs: { width: "10%" } }),
              _c("col", { attrs: { width: "10%" } }),
              _c("col", { attrs: { width: "5%" } }),
              _c("col", { attrs: { width: "5%" } }),
              _c("col", { attrs: { width: "8%" } }),
              _c("col", { attrs: { width: "8%" } }),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.waitingList, function (waiting, i) {
                return _c("tr", { key: i }, [
                  _c("td", { staticClass: "align-center truncate" }, [
                    _vm._v(_vm._s(i + 1)),
                  ]),
                  _c("td", { staticClass: "truncate" }, [
                    _vm._v(_vm._s(waiting.nickName)),
                  ]),
                  _c("td", { staticClass: "truncate" }, [
                    _vm._v(
                      _vm._s(
                        _vm
                          .dayjs(waiting.joinDate)
                          .format("YYYY-MM-DD HH:mm:ss")
                      )
                    ),
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "align-center truncate",
                      class: [
                        waiting.cameraStatus === "on" ? "success" : "error",
                      ],
                    },
                    [
                      _vm._v(
                        _vm._s(
                          waiting.cameraStatus === "on"
                            ? _vm.$t("common.normal")
                            : _vm.$t("common.error")
                        )
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "align-center truncate",
                      class: [waiting.micStatus === "on" ? "success" : "error"],
                    },
                    [
                      _vm._v(
                        _vm._s(
                          waiting.micStatus === "on"
                            ? _vm.$t("common.normal")
                            : _vm.$t("common.error")
                        )
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    { staticClass: "align-center truncate" },
                    [
                      _c("GrmSelect", {
                        attrs: {
                          maxContent: "",
                          white: "",
                          options: _vm.userRoleOptions,
                        },
                        on: {
                          input: (roleId) =>
                            _vm.changeUserRole(waiting, roleId),
                        },
                      }),
                    ],
                    1
                  ),
                  _c("td", { staticClass: "align-center" }, [
                    _c(
                      "div",
                      { staticClass: "room-waiting-button-container" },
                      [
                        _c(
                          "VButton",
                          {
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.approveApi({
                                  roomId: _vm.room.roomId,
                                  userId: waiting.userId,
                                  roleId: waiting.joinRoleId,
                                })
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.apply")))]
                        ),
                        _c(
                          "VButton",
                          {
                            attrs: { small: "", cancel: "" },
                            on: {
                              click: function ($event) {
                                _vm.$alert({
                                  text: _vm.$t(
                                    "waitingRoom.confirm.disapprove",
                                    { 0: waiting.nickName }
                                  ),
                                  ok: () => {
                                    _vm.disapproveApi({
                                      roomId: _vm.room.roomId,
                                      userId: waiting.userId,
                                      roleId: waiting.joinRoleId,
                                    })
                                  },
                                })
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.reject")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "10%" } }),
      _c("col", { attrs: { width: "10%" } }),
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "8%" } }),
      _c("col", { attrs: { width: "8%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }